import React, { useEffect, useState } from "react";
import GuiaBanner from '../components/GuiaBanner';
import { Link, useNavigate } from "react-router-dom";
import SafeIcon from "../common/SafeIcon";
import OnboardingFlow from "../components/onboarding/OnboardingFlow";
import { registerVisitAndCheckReturn } from "../lib/visitDays";
import { useLocale } from '../components/LocaleProvider';

export default function Dashboard() {
  const { locale } = useLocale();
  const spanish = locale === 'es';
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showOnboarding, setShowOnboarding] = useState(false);
  useEffect(() => {
    fetch("/api/auth/session", { credentials: "same-origin" })
      .then((response) => response.json())
      .then((payload) => payload.user ? setUser(payload.user) : navigate("/pro?access=login", { replace: true }))
      .catch(() => navigate("/pro?access=login", { replace: true }));
  }, [navigate]);

  // Cobre quem já tinha sessão aberta antes do onboarding existir, ou entrou direto
  // nesta URL sem passar pelo login agora.
  useEffect(() => {
    if (!user) return;
    fetch("/api/auth/onboarding-status", { credentials: "same-origin" })
      .then((response) => response.json())
      .then((payload) => {
        if (payload.showOnboarding) { setShowOnboarding(true); return; }
        // Só datas de visita ficam no navegador; avisa o servidor uma vez quando a pessoa volta em outro dia.
        let storage = null;
        try { storage = window.localStorage; } catch { storage = null; }
        if (registerVisitAndCheckReturn(storage)) {
          fetch("/api/auth/onboarding-profile", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ evento: "retorno" }),
          }).catch(() => {});
        }
      })
      .catch(() => {});
  }, [user]);

  if (!user) return <main className="mx-auto min-h-[64vh] max-w-[680px] px-4 py-20"><p className="text-[var(--text-muted)]">{spanish ? 'Verificando tu cuenta…' : 'Verificando sua conta…'}</p></main>;
  if (showOnboarding) return <OnboardingFlow name={user.name} email={user.email} onDone={() => setShowOnboarding(false)} />;
  return <main className="mx-auto min-h-[64vh] max-w-[680px] px-4 py-20">
    <section className="card p-7">
      <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[var(--accent-tint)] text-[var(--accent)]" aria-hidden="true">
        <SafeIcon name="Shield" className="h-6 w-6" />
      </span>
      <p className="eyebrow">{spanish ? 'Mi cuenta' : 'Minha conta'}</p>
      <h1 className="mt-3 text-[var(--primary)]">{spanish ? 'Hola' : 'Olá'}, {user.name || user.email}.</h1>
      <p className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--success)]">
        <SafeIcon name="Check" className="h-4 w-4" />
        {spanish ? 'Plan Founder — acceso de por vida' : 'Plano Founder — Vitalício'}
      </p>
      <p className="mt-2 leading-relaxed text-[var(--text-muted)]">{spanish ? 'Tu cuenta está activa e incluye acceso completo a MiniMental.' : 'Sua conta está ativa e inclui o acesso completo ao MiniMental.'}</p>
      <Link to="/dashboard" className="btn-primary mt-6 no-underline">{spanish ? 'Abrir panel clínico' : 'Abrir dashboard clínico'}</Link>
    </section>
    {!spanish && <GuiaBanner placement="conta" className="mt-6" />}
  </main>;
}
